export default "__VITE_ASSET__Cf9B1rdy__"